import React from 'react'
import RouterComponent from './router';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
        <RouterComponent />
    </Provider>
  );
}

export default App;
